<template>
    <!-- my code -->
        <div class="wrapper-main-content">
        <!-- sidebar -->
        <div class="sidebar">
            <side-bar
            :step="step"
            :sidebarListLinks="sidebarListLinks"
            ></side-bar>
        </div>
        <!-- sidebar ends -->

        <!-- form -->
            <div class="main_content-form">
                <div class="contractor-form-box position-relative p-4">
                <div class="card-body">
                    <h1 class="head-title font-weight-bold text-center">
                    Create Strata Plan
                    </h1>

                    <b-form @submit.prevent="componentFormSubmitted" class="mt-5">
                    <b-form-group>
                        <template v-slot:label>
                        Strata Plan ID <span class="text-danger">*</span>
                        </template>
                        <b-input-group>
                        <template #prepend>
                            <b-form-select
                            v-model="componentForm.type"
                            :options="strataPlanTypeOptions"
                            style="border-radius: 15px 0px 0px 15px"
                            ></b-form-select>
                        </template>
                        <b-form-input
                            type="text"
                            v-model="componentForm.strata_plan_number"
                            :aria-describedby="ariaDescribedby"
                            v-bind:class="{
                            'is-invalid': form.errors.has('strata_plan_number'),
                            }"
                        ></b-form-input>
                        <has-error
                            :form="form"
                            field="strata_plan_number"
                        ></has-error>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group>
                        <template v-slot:label>
                        Strata Manager <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                        v-model="componentForm.strata_manager_id"
                        :aria-describedby="ariaDescribedby"
                        :options="managers"
                        v-bind:class="{
                            'is-invalid': form.errors.has('strata_manager_id'),
                        }"
                        @change="handleManagerChanged($event)"
                        ></b-form-select>
                        <has-error :form="form" field="strata_manager_id"></has-error>
                        <div v-show="hasSelectedManagerInfo" class="mt-2">
                        <p class="mb-0">Phone: {{ selectedManager.phone }}</p>
                        <p class="mb-0">Email: {{ selectedManager.email }}</p>
                        </div>
                    </b-form-group>

                    <b-form-group label="Alternative Manager">
                        <treeselect
                        v-model="componentForm.alternate_manager_id"
                        :multiple="false"
                        :options="alternate_manager"
                        />
                        <!-- <b-form-select
                        v-model="componentForm.alternate_manager_id"
                        :aria-describedby="ariaDescribedby"
                        :options="managers"
                        v-bind:class="{
                            'is-invalid': form.errors.has('alternate_manager_id'),
                        }"
                        >
                        <template #first>
                        <b-form-select-option :value="null">I dont have any alternative manager</b-form-select-option>
                        </template></b-form-select> -->
                        <has-error
                        :form="form"
                        field="alternate_manager_id"
                        ></has-error>
                    </b-form-group>

                    <div class="builder-component mb-4">
                        <b-form-group>
                        <template v-slot:label> Building Manager - Name </template>
                        <b-form-input
                            style=""
                            placeholder="Full Name"
                            type="text"
                            v-model="componentForm.building_manager_name"
                            :aria-describedby="ariaDescribedby"
                            v-bind:class="{
                            'is-invalid': form.errors.has('building_manager_name'),
                            }"
                        ></b-form-input>
                        <has-error
                            :form="form"
                            field="building_manager_name"
                        ></has-error>
                        </b-form-group>

                        <b-form-group>
                        <template v-slot:label> Building Manager - Email </template>
                        <b-form-input
                            style=""
                            placeholder="E-mail Address"
                            type="text"
                            v-model="componentForm.building_manager_email"
                            :aria-describedby="ariaDescribedby"
                            v-bind:class="{
                            'is-invalid': form.errors.has('building_manager_email'),
                            }"
                        ></b-form-input>
                        <has-error
                            :form="form"
                            field="building_manager_email"
                        ></has-error>
                        </b-form-group>

                        <b-form-group>
                        <template v-slot:label> Building Manager - Phone </template>
                        <b-form-input
                            style=""
                            placeholder="Phone Number"
                            type="text"
                            v-model="componentForm.formattedPhone"
                            :aria-describedby="ariaDescribedby"
                            v-bind:class="{
                            'is-invalid': form.errors.has('building_manager_phone'),
                            }"
                            @keyup="formatPhone"
                        ></b-form-input>
                        <has-error
                            :form="form"
                            field="building_manager_phone"
                        ></has-error>
                        </b-form-group>
                    </div>

                    <b-form-group>
                        <template v-slot:label>
                        ABN/ACN <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        v-model="componentForm.abn_acn"
                        @keyup="abnNumber"
                        v-bind:class="{
                            'is-invalid': form.errors.has('abn_acn'),
                        }"
                        ></b-form-input>
                        <has-error :form="form" field="abn_acn"></has-error>
                    </b-form-group>

                    <b-form-group>
                        <template v-slot:label>
                        Annual Budget Estimate (exc. GST) - 2021/2022
                        </template>
                        <b-input-group size="md" prepend="$">
                        <b-form-input
                            placeholder="Max Value"
                            type="text"
                            v-model="componentForm.formattedEstimatedBudget"
                            :aria-describedby="ariaDescribedby"
                            v-bind:class="{
                            'is-invalid': form.errors.has('estimated_budget'),
                            }"
                            @keyup="estimatedBudgetFormat"
                        ></b-form-input>
                        </b-input-group>
                        <has-error :form="form" field="estimated_budget"></has-error>
                    </b-form-group>

                    <b-button
                        class="btn-grad"
                        :disabled="form.busy"
                        type="submit"
                        variant="primary"
                        style="float: right"
                        >Next
                    </b-button>
                    </b-form>
                </div>
            </div>
            </div>
        <!-- form  ends -->
        </div>
    <!-- my code ends -->


</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { HasError } from "vform";
import _ from "lodash";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin";
import Treeselect from "@riophae/vue-treeselect";

export default {
  props: [
    "form",
    "step",
    "sidebarListLinks",
    "eventParentToChildComponentFrom",
  ],
  components: {
    NavBar,
    FooterComponent,
    SideBar,
    HasError,
    Treeselect,
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      componentForm: {
        strata_plan_number: "",
        strata_manager_id: "",
        alternate_manager_id: "",
        building_manager_name: "",
        building_manager_email: "",
        building_manager_phone: "",
        formattedEstimatedBudget: "",
        estimated_budget: "",
        formattedPhone: "",
        abn_acn: "",
        type: "SP",
      },
      strataPlanTypeOptions: [
        { value: "SP", text: "SP" },
        { value: "DP", text: "DP" },
      ],
      managers: [],
      selectedManager: {},
      alternate_manager: [],
    };
  },
  mounted() {
    _.forEach(this.form, (value, field) => {
      if (field in this.componentForm) {
        this.componentForm[field] = value;
      }
    });

    //Called by parent from index page
    this.eventParentToChildComponentFrom.$on(
      "event-parent-child-componentform",
      this.eventFromParentToChildComponentForm
    );

    this.filterManager();
    this.getAlternatemanager();

    // if(this.$route.params.id != "new"){
   
    //   this.handleManagerChanged(this.strata_manager_id);
    // };

  },
  methods: {
    componentFormSubmitted() {
      this.$emit("componentFormSubmitted", this.componentForm, 1);
    },
    filterManager() {
      axios.post("api/manager/strata-plan/filterManager").then((response) => {
        this.managers = response.data.managers.map((manager) => {
          return {
            value: manager.id,
            text: `${manager.first_name} ${manager.last_name}`,
          };
        });
      });
    },
    getAlternatemanager() {
      axios
        .post("api/manager/strata-plan/getAlternativeManager")
        .then((response) => {
          this.alternate_manager = response.data.alternate_manager.map(
            (manager) => {
              return {
                id: manager.id,
                label: `${manager.first_name} ${manager.last_name}`,
              };
            }
          );
          this.alternate_manager.unshift({
            id: "",
            label: "",
          });
        });
    },
    handleManagerChanged(manager_id) {
      axios
        .post("api/manager/strata-plan/getManagerDetails", { manager_id })
        .then((response) => {
          this.selectedManager = response.data.manager;
          this.selectedManager.phone = this.formatPhoneForAustraliaBySpace(
            this.selectedManager.user_phone
          );
        });
    },
    formatPhone() {
      this.componentForm.building_manager_phone = this.componentForm.formattedPhone ? this.getPhoneDigitsOnly(this.componentForm.formattedPhone) : null;
      this.componentForm.formattedPhone =  this.componentForm.building_manager_phone ? this.formatPhoneForAustralia(this.componentForm.building_manager_phone) : null;
    },
    eventFromParentToChildComponentForm(value) {
      _.forEach(value.data, (value, field) => {
        if (field in this.componentForm) {
          this.componentForm[field] = value;
        }
      });
    },
    estimatedBudgetFormat() {
      this.componentForm.estimated_budget =
        this.componentForm.formattedEstimatedBudget.replace(/\D/g, "");
      this.componentForm.formattedEstimatedBudget =
        this.componentForm.formattedEstimatedBudget
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    abnNumber() {
      this.componentForm.abn_acn = this.getABNACNDigitsOnly(
        this.componentForm.abn_acn
      );
    },
  },
  computed: {
    hasSelectedManagerInfo() {
      return !_.isEmpty(this.selectedManager);
    },
  },
};
</script>
